// Fonte: UManutContas.dfm — Painel P4, Ds_Fornecedor → tabela Fornecedor
// Fluxo especial: Na inclusão, abre busca de Cadastro Único ANTES de preencher campos
import React, { useState } from 'react';
import { Form, Row, Col, Card, Collapse } from 'react-bootstrap';
import Select from 'react-select';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import aplicarMascara from './mascaras';

var TIPO_PESSOA = [
  { value: '0', label: 'Física' },
  { value: '1', label: 'Jurídica' },
];

var ETIQUETA = [
  { value: 'S', label: 'Sim' },
  { value: 'N', label: 'Não' },
];

var FormTipo4 = function(_ref) {
  var formik = _ref.formik;
  var modoEdicao = _ref.modoEdicao;
  var lookups = _ref.lookups;
  var lookupsLoading = _ref.lookupsLoading;

  var cidades = (lookups && lookups.cidades) ? lookups.cidades : [];
  var tabelasPrecos = (lookups && lookups.tabelasPrecos) ? lookups.tabelasPrecos : [];

  // Fonte: UManutContas.dfm L9170/L9347 — DDD e UF readonly de Ds_Tab_Cidades
  var cidadeSelecionada = cidades.find(function(c) {
    return c.value === (formik.values.tipo4 ? formik.values.tipo4.codigo_cidade : null);
  });
  var ddd = cidadeSelecionada && cidadeSelecionada.ddd !== undefined && cidadeSelecionada.ddd !== null ? String(cidadeSelecionada.ddd) : '';
  var uf = cidadeSelecionada && cidadeSelecionada.uf ? cidadeSelecionada.uf : '';

  var val = function(campo) {
    var v = formik.values['tipo4'] ? formik.values['tipo4'][campo] : undefined;
    return v !== null && v !== undefined ? v : '';
  };

  var handleChange = function(e) {
    formik.setFieldValue('tipo4.' + e.target.name, e.target.value);
  };

  var handleMasked = function(name, tipo) {
    return function(e) {
      formik.setFieldValue('tipo4.' + name, aplicarMascara(e.target.value, tipo));
    };
  };

  var valMask = function(campo, tipo) {
    return aplicarMascara(val(campo), tipo);
  };

  var isInternacional = val('internacional') === 'S';

  var [aberto, setAberto] = useState(true);

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header className="py-2 contas-card-header" style={{ cursor: 'pointer' }} onClick={function() { setAberto(!aberto); }}>
        <div className="d-flex justify-content-between align-items-center">
          <strong>Dados do Tipo: Fornecedor</strong>
          {aberto ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
        </div>
      </Card.Header>
      <Collapse in={aberto}>
        <div>
      <Card.Body>
        <Row>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Nome / Razão Social *</Form.Label>
            <Form.Control
              type="text" size="sm" name="razao_social"
              value={val('razao_social')} onChange={handleChange}
              maxLength={40} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">
              CPF/CNPJ {!isInternacional && '*'}
            </Form.Label>
            <Form.Control
              type="text" size="sm" name="cpf"
              value={valMask('cpf', 'cpf')} onChange={handleMasked('cpf', 'cpf')}
              maxLength={18} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Tipo Pessoa *</Form.Label>
            <Select
              options={TIPO_PESSOA}
              value={TIPO_PESSOA.find(function(t) { return t.value === val('tipo_pessoa'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo4.tipo_pessoa', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">RG</Form.Label>
            <Form.Control
              type="text" size="sm" name="rg"
              value={val('rg')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3 d-flex align-items-end pb-1">
            <Form.Check
              type="checkbox"
              label="Internacional"
              checked={val('internacional') === 'S'}
              onChange={function(e) {
                formik.setFieldValue('tipo4.internacional', e.target.checked ? 'S' : 'N');
              }}
              disabled={!modoEdicao}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Endereço</Form.Label>
            <Form.Control
              type="text" size="sm" name="endereco"
              value={val('endereco')} onChange={handleChange}
              maxLength={40} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Bairro</Form.Label>
            <Form.Control
              type="text" size="sm" name="bairro"
              value={val('bairro')} onChange={handleChange}
              maxLength={20} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">CEP</Form.Label>
            <Form.Control
              type="text" size="sm" name="cep"
              value={valMask('cep', 'cep')} onChange={handleMasked('cep', 'cep')}
              maxLength={9} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Cidade *</Form.Label>
            <Select
              placeholder="Selecione a cidade..."
              options={cidades}
              value={cidades.find(function(c) { return c.value === val('codigo_cidade'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo4.codigo_cidade', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isLoading={lookupsLoading}
              noOptionsMessage={function() { return 'Nenhuma cidade'; }}
            />
          </Col>
          <Col md={1} className="mb-3">
            <Form.Label className="small mb-1">UF</Form.Label>
            <Form.Control type="text" size="sm" value={uf} readOnly disabled />
          </Col>
          <Col md={1} className="mb-3">
            <Form.Label className="small mb-1">DDD</Form.Label>
            <Form.Control type="text" size="sm" value={ddd} readOnly disabled />
          </Col>
        </Row>
        <Row>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Fone 1 *</Form.Label>
            <Form.Control
              type="text" size="sm" name="fone1"
              value={valMask('fone1', 'fone')} onChange={handleMasked('fone1', 'fone')}
              maxLength={14} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Fone 2</Form.Label>
            <Form.Control
              type="text" size="sm" name="fone2"
              value={valMask('fone2', 'fone')} onChange={handleMasked('fone2', 'fone')}
              maxLength={14} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Fax</Form.Label>
            <Form.Control
              type="text" size="sm" name="fax"
              value={valMask('fax', 'fone')} onChange={handleMasked('fax', 'fone')}
              maxLength={14} disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Contato</Form.Label>
            <Form.Control
              type="text" size="sm" name="contato"
              value={val('contato')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">E-mail</Form.Label>
            <Form.Control
              type="email" size="sm" name="email"
              value={val('email')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
        </Row>
        <Row>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Prazo Fabricante</Form.Label>
            <Form.Control
              type="text" size="sm" name="prazo_fabricante"
              value={val('prazo_fabricante')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Etiqueta</Form.Label>
            <Select
              options={ETIQUETA}
              isClearable
              value={ETIQUETA.find(function(e) { return e.value === val('etiqueta'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo4.etiqueta', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Tab. Compra</Form.Label>
            <Select
              placeholder="Selecione..."
              options={tabelasPrecos}
              isLoading={lookupsLoading}
              value={tabelasPrecos.find(function(t) { return t.value === val('codigo_tabela'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo4.codigo_tabela', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isClearable
              noOptionsMessage={function() { return 'Nenhuma tabela'; }}
            />
          </Col>
        </Row>
      </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
};

export default FormTipo4;
